import {Component, OnInit, ViewChild} from '@angular/core';
import {ToothService} from '../../../../services/tooth.service';
import {ToothConfigurationModel} from '../../../../models/teeth/tooth-configuration.model';
import {FeeCodeForToothConfiguration} from '../../../../models/teeth/fee-code-for-tooth.configuration';
import {FeeCodeToothConfiguration} from '../../../../models/teeth/fee-code-tooth.configuration';
import {TdoTableV2Component} from '../../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import {MatCheckbox, MatCheckboxChange} from '@angular/material/checkbox';
import {EnumValidValueItemModel} from '../../../../models/enum/enum-valid-value-item.model';
import {TdoEnumSelectComponent} from '../../../../tdo-controls/common/tdo-enum-select/tdo-enum-select.component';
import {TdoTableSelectionEvent} from '../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import {DialogService} from '../../../../services/dialog.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ConfigurationService} from '../../configuration.service';

@Component({
  selector: 'app-code-for-teeth',
  templateUrl: './code-for-teeth.component.html',
  styleUrls: ['./code-for-teeth.component.scss']
})
export class CodeForTeethComponent implements OnInit {
  @ViewChild('codesTable') codesTable: TdoTableV2Component;
  @ViewChild('enumSelect') enumSelect: TdoEnumSelectComponent;

  isLoading: boolean = true;
  cfgTeeth: ToothConfigurationModel[] = [];
  codesForTeeth: FeeCodeForToothConfiguration[] = [];
  selectedCodeForTeeth: FeeCodeForToothConfiguration;

  constructor(private toothService: ToothService,
              private dialogService: DialogService,
              private snackbar: MatSnackBar,
              public configurationService: ConfigurationService) { }

  ngOnInit(): void {
    this.isLoading = true;
    this.toothService.getAllTeeth(ToothService.enumUnitedStatesToothGrouping).subscribe((tres) => {
      this.cfgTeeth = tres;

      this.toothService.getFeeCodeTeeth().subscribe((res) => {
        this.codesForTeeth = res;
        if (this.codesForTeeth && this.codesForTeeth.length > 0) {

          if(this.selectedCodeForTeeth == null) {
            this.selectedCodeForTeeth = this.codesForTeeth[0];
          }
        }
        this.isLoading = false;
      });
    });
  }

  onNew() {
    const c = new FeeCodeForToothConfiguration();
    c.Code = 'New';
    c.Description = 'New';
    c.Teeth = [];
    this.codesForTeeth.unshift(c);
    this.selectedCodeForTeeth = c;
    this.codesTable.updateData(this.codesForTeeth);
  }

  onSave() {



    this.toothService.saveCodeForTeeth(this.selectedCodeForTeeth).subscribe(() => {
      this.configurationService.setClean();

      //reload
      this.ngOnInit();



      this.snackbar.open('Save success',  null, { duration: 3000, verticalPosition: 'top' });
    }, (e) => {


      this.snackbar.open('Error: Code not found in TDO DB.',  null, { duration: 3000, verticalPosition: 'top', politeness: 'assertive'});
    });
  }

  getToothNum(i: ToothConfigurationModel) {
    const cfg = this.cfgTeeth.find(p => p.ToothId.toLowerCase() === i.ToothId.toLowerCase());
    if (cfg) {
      return cfg.cfgToothDescriptions[0].Notation;
    }
  }

  onToothSelect(cb: MatCheckbox, i: ToothConfigurationModel) {
    cb.checked = !cb.checked;

    if (cb.checked) {
      if (!this.selectedCodeForTeeth.Teeth.map(p => p.ToothId).includes(i.ToothId)) {
        const tooth = new FeeCodeToothConfiguration();
        tooth.Code = this.selectedCodeForTeeth.Code;
        tooth.ToothId = i.ToothId;
        tooth.isSelected = true;
        this.selectedCodeForTeeth.Teeth.push(tooth);
      }
    } else {
      const existing = this.selectedCodeForTeeth.Teeth.find(p => p.ToothId.toLowerCase() === i.ToothId.toLowerCase());
      if (existing) {
        existing.isSelected = false;
      }
    }

    this.enumSelect.reset();

  }

  getFirstEight() {
    const t = this.cfgTeeth;
    const a = [t[0], t[1], t[2], t[3], t[4], t[5], t[6], t[7]];
    return a;
  }

  getSecondEight() {
    const t = this.cfgTeeth;
    const a = [t[8], t[9], t[10], t[11], t[12], t[13], t[14], t[15]];
    return a;
  }

  getThirdEight() {
    const t = this.cfgTeeth;
    const a = [t[16], t[17], t[18], t[19], t[20], t[21], t[22], t[23]];
    return a;
  }

  getFourthEight() {
    const t = this.cfgTeeth;
    const a = [t[24], t[25], t[26], t[27], t[28], t[29], t[30], t[31]];
    return a;
  }

  onAllChange(event: MatCheckboxChange) {
    this.enumSelect.reset();
    if (event.checked) {
      for (const t of this.cfgTeeth) {
        if (!this.selectedCodeForTeeth.Teeth.map(p => p.ToothId).includes(t.ToothId)) {
          const tooth = new FeeCodeToothConfiguration();
          tooth.Code = this.selectedCodeForTeeth.Code;
          tooth.ToothId = t.ToothId;
          tooth.isSelected = true;
          this.selectedCodeForTeeth.Teeth.push(tooth);
        }
      }
    } else {
      this.selectedCodeForTeeth.Teeth = [];
    }
  }

  isToothSelected(i: ToothConfigurationModel) {
    const existing = this.selectedCodeForTeeth.Teeth.find(p => p.ToothId.toLowerCase() === i.ToothId.toLowerCase());
    if (existing && existing.isSelected) {
      return true;
    }
    return false;
    /*return this.selectedCodeForTeeth.Teeth.map(p => p.ToothId).includes(i.ToothId);*/
  }

  onToothGroupSelected(event: EnumValidValueItemModel) {
    const teethForLocation = this.cfgTeeth.filter(p => {
      const t = p.cfgToothLocations.find(e => e.enumToothLocationId === event.ValidValueItemId);
      if (t) {
        return p;
      }
    });

    this.selectedCodeForTeeth.Teeth = [];
    for (const t of teethForLocation) {
      const tooth = new FeeCodeToothConfiguration();
      tooth.Code = this.selectedCodeForTeeth.Code;
      tooth.ToothId = t.ToothId;
      tooth.isSelected = true;
      this.selectedCodeForTeeth.Teeth.push(tooth);
    }
  }

  onTableRowSelected(event: TdoTableSelectionEvent) {
    const l = this.configurationService.checkIsDirty();
    if (l) {
      l.subscribe((res) => {
        if (res) {
          this.selectedCodeForTeeth = event.model as FeeCodeForToothConfiguration;
          return;
        } else {
          this.codesTable.selectionControl.select(this.selectedCodeForTeeth);
        }
      });
    } else {
      this.selectedCodeForTeeth = event.model as FeeCodeForToothConfiguration;
    }
  }

  onDelete(model: FeeCodeForToothConfiguration) {
    this.dialogService.openConfirmDialog('Are you sure you want to delete ' + model.Code + '?').subscribe((res) => {
      if (res) {
        this.toothService.deleteFeeCodeForTooth(model).subscribe(() => {
          const idx = this.codesForTeeth.findIndex(p => p.Code.toLowerCase() === model.Code.toLowerCase());
          if (idx > -1) {
            this.codesForTeeth.splice(idx, 1);
            this.snackbar.open('Delete success',  null, { duration: 3000, verticalPosition: 'top' });
            this.codesTable.updateData(this.codesForTeeth);
            if (this.codesForTeeth.length > 0 && this.selectedCodeForTeeth.Code.toLowerCase() === model.Code.toLowerCase()) {
              this.selectedCodeForTeeth = this.codesForTeeth[0];
            }
          }
        }, (e) => {
          // This must have been one that was added but never saved.
          const idx = this.codesForTeeth.findIndex(p => p === model);
          if (idx > -1) {
            this.codesForTeeth.splice(idx, 1);
            this.snackbar.open('Delete success',  null, { duration: 3000, verticalPosition: 'top' });
            this.codesTable.updateData(this.codesForTeeth);
            if (this.codesForTeeth.length > 0 && this.selectedCodeForTeeth.Code.toLowerCase() === model.Code.toLowerCase()) {
              this.selectedCodeForTeeth = this.codesForTeeth[0];
            }
          }
        });
      }
    });
  }

  onCodeInput(event: string) {
    if (!this.codesForTeeth.map(p => p.Code).includes(event)) {
      this.selectedCodeForTeeth.Code = event;
    } else {
      this.dialogService.openConfirmDialog('This code already exists.  Would you like to select it and make changes?  Cancel to change this code yourself.').subscribe((res) => {
        if (res) {
          this.codesForTeeth.splice(0 , 1);
          this.codesTable.updateData(this.codesForTeeth);
          this.selectedCodeForTeeth = this.codesForTeeth.find(p => p.Code.toLowerCase() === event.toLowerCase());
        } else {
          this.selectedCodeForTeeth.Code = '';
        }
      });
    }
  }
}
